import Axios from "axios";
import { SETTINGS } from "../properties/Settings";

export const AlertRepository = {
    getAllActiveByType: (payload) =>{
        return Axios({
            url: SETTINGS.API_URL + "alerts",
            method: "GET",
            params: {
                type: payload.type
            },
        });
    },
}